const DiningSearchView = () => import(/* webpackChunkName: "ds" */'@/views/DiningSearchView');
const DiningSingleView = () => import(/* webpackChunkName: "dss" */'@/views/DiningSingleView');
import makeSingleMapSightRoute from '../utils/createSingleMapSightRoute';


const diningSightMapRouter = [
  makeSingleMapSightRoute({
    sightMapType: 'dining',
    category: 'dining',
    path: 'dining/qtsas-restaurant',
    route: {
      path: '',
      name: `dining-search`,
      component: DiningSearchView
    }
  }),
  makeSingleMapSightRoute({
    sightMapType: 'dining',
    category: 'dining',
    path: 'dining/qtsas-restaurant/:entity',
    route: {
      path: '',
      name: `dining-single`,
      component: DiningSingleView
    }
  }),
];

export default diningSightMapRouter;